import { Star } from "lucide-react";
import ResourceManager, { ActiveBadge } from "@/components/admin/ResourceManager";

const fields = [
    { name: "client_name", label: "Client name", type: "text", required: true },
    { name: "business_name", label: "Business name", type: "text", required: true },
    { name: "review_text", label: "Review", type: "textarea", rows: 5, required: true },
    {
        name: "rating",
        label: "Rating (1-5)",
        type: "select",
        default: "5",
        options: [
            { value: "5", label: "★★★★★ (5)" },
            { value: "4", label: "★★★★☆ (4)" },
            { value: "3", label: "★★★☆☆ (3)" },
            { value: "2", label: "★★☆☆☆ (2)" },
            { value: "1", label: "★☆☆☆☆ (1)" },
        ],
    },
    { name: "image", label: "Avatar image", type: "image" },
    { name: "order", label: "Sort order", type: "number" },
    { name: "is_active", label: "Active", type: "switch", default: true, toggleLabel: "Visible on site" },
];

const columns = [
    { key: "client_name", label: "Name" },
    { key: "business_name", label: "Business" },
    {
        key: "rating",
        label: "Rating",
        render: (r) => (
            <span className="inline-flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                        key={i}
                        className={`w-3.5 h-3.5 ${i < (r.rating || 0) ? "fill-amber-400 text-amber-400" : "text-slate-200"}`}
                    />
                ))}
            </span>
        ),
    },
    { key: "is_active", label: "Status", render: (r) => <ActiveBadge active={r.is_active} /> },
];

// Convert rating select string -> int before submit
function adaptFields(items) {
    return items.map((it) => ({
        ...it,
        // ensure rating int when coming from server; select expects string
    }));
}

export default function TestimonialsPage() {
    // Wrap to coerce rating string -> int
    return (
        <ResourceManager
            title="Testimonials"
            description="Client reviews and ratings displayed across the website."
            endpoint="testimonials"
            columns={columns}
            fields={fields.map((f) =>
                f.name === "rating"
                    ? {
                          ...f,
                          // Select stores string; ResourceManager submits formData as-is
                          // We need rating as int — handled by Pydantic coercion server-side
                      }
                    : f,
            )}
            testidPrefix="testimonials"
            searchKeys={["client_name", "business_name"]}
        />
    );
}
